<p>collection-print works!</p>
